import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './utils/gtm-init';
import './index.css';
import { App } from './App';
import { ScrollToTop } from './components/ScrollToTop';
import { Home } from './pages/Home';
import { Clinics } from './pages/Clinics';
import { Packages } from './pages/Packages';
import { Treatments } from './pages/Treatments';
import { About } from './pages/About';
import { Contact } from './pages/Contact';
import { Disclaimers } from './pages/Disclaimers';
import { MedicalDisclaimer } from './pages/MedicalDisclaimer';
import { PrivacyPolicy } from './pages/PrivacyPolicy';
import { TermsOfService } from './pages/TermsOfService';
import { CookiePolicy } from './pages/CookiePolicy';
const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(<React.StrictMode data-id="element-831">
    <BrowserRouter data-id="element-832">
      <ScrollToTop data-id="element-833" />
      <Routes data-id="element-834">
        <Route path="/" element={<App data-id="element-836">
              <Home data-id="element-837" />
            </App>} data-id="element-835" />
        <Route path="/clinics" element={<App data-id="element-839">
              <Clinics data-id="element-840" />
            </App>} data-id="element-838" />
        <Route path="/packages" element={<App data-id="element-842">
              <Packages data-id="element-843" />
            </App>} data-id="element-841" />
        <Route path="/treatments" element={<App data-id="element-845">
              <Treatments data-id="element-846" />
            </App>} data-id="element-844" />
        <Route path="/about" element={<App data-id="element-848">
              <About data-id="element-849" />
            </App>} data-id="element-847" />
        <Route path="/contact" element={<App data-id="element-851">
              <Contact data-id="element-852" />
            </App>} data-id="element-850" />
        <Route path="/medical-disclaimer" element={<App data-id="element-854">
              <MedicalDisclaimer data-id="element-855" />
            </App>} data-id="element-853" />
        <Route path="/privacy-policy" element={<App data-id="element-857">
              <PrivacyPolicy data-id="element-858" />
            </App>} data-id="element-856" />
        <Route path="/terms-of-service" element={<App data-id="element-860">
              <TermsOfService data-id="element-861" />
            </App>} data-id="element-859" />
        <Route path="/cookie-policy" element={<App data-id="element-863">
              <CookiePolicy data-id="element-864" />
            </App>} data-id="element-862" />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>);